
export default {
  name: 'NumberAnimate',
  props: {
    num: {
      type: Number,
      default: 0,
    },
    digit: {
      type: Number,
      default: 0,
    },
    showMil: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newNum: 0,
      step: 0,
    }
  },
  watch: {
    // 这里使用对象，直接imme 就报错了活见久
    num(cval) {
      this.step = cval / 15
      this.doAnimate()
    },
  },
  mounted() {
    this.step = this.num / 15
    this.doAnimate()
  },
  methods: {
    doAnimate() {
      const timer = setTimeout(() => {
        clearTimeout(timer)

        if (this.newNum < this.num) {
          this.newNum += this.step
        } else {
          this.newNum = this.num
        }

        if (this.newNum != this.num) {
          this.doAnimate()
        }
      }, 60)
    },
    numberFormat(number) {
      return this.showMil
        ? Number(parseFloat(number).toFixed(this.digit)).toLocaleString()
        : parseFloat(number).toFixed(this.digit)
    },
  },
}
